import {lockButton, unlockButton, validateForm} from '../../form-utils/base';
import {showAlert} from '../../form-utils/alert';
import {api} from '../../api';

/**
 * Класс для обработки отправки форм с валидацией и API запросами
 *
 * @class BaseForm
 */
class BaseForm {
    /**
     * @param {string} props.fromSelector - селектор элемента формы
     * @param {string} props.formSubmitSelector - селектор кнопки отправки внутри формы
     * @param {Object} props.settings - настройки формы
     * @param {string} props.settings.api - URL API эндпоинта для отправки данных
     * @param {Function} props.settings.callbackBySend - Callback, вызываемый после успешной отправки
     */
    constructor(props) {
        this.formSelector = props.fromSelector;
        this.formElement = document.querySelector(props.fromSelector);
        this.formTriggerSubmit = this.formElement?.querySelector(props.formSubmitSelector);
        this.settings = props.settings;

        this.initializeForm();
    }

    /**
     * Инициализирует форму
     */
    initializeForm() {
        if (!this.formElement) {
            console.warn(`Не удалось найти форму ${this.formSelector}`);
            return;
        }

        this.handleFormSubmit();
    }

    /**
     * Обрабатывает отправку формы
     */
    handleFormSubmit() {
        this.formElement.addEventListener('submit', (event) => {
            event.preventDefault();

            if (!validateForm(this.formElement)) {
                return;
            }

            lockButton(this.formTriggerSubmit);

            const formData = new FormData(this.formElement);

            this.sendMessage(formData);
        });
    }

    /**
     * Отправляет данные формы на сервер
     */
    sendMessage(formData) {
        const apiUrl = this.settings.api.replace(/^\//, '');

        api.post(apiUrl, {body: formData})
            .then((response) => response.json())
            .then((data) => {
                if (!data.status) {
                    return;
                }

                showAlert(this.formElement, 'beforebegin', data.message, 'success');

                this.formElement.reset();

                if (this.settings.callbackBySend) {
                    this.settings.callbackBySend();
                }
            })
            .catch(async (error) => {
                const errorMessage = await error.response.json();

                showAlert(this.formElement, 'beforebegin', errorMessage.message, 'error');
            })
            .finally(() => {
                unlockButton(this.formTriggerSubmit);
            });
    }
}

export default BaseForm;
